/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997AddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: ProductSalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';
import { ProductSalesfor1997Data, ProductSalesfor1997Service }  from './ProductSalesfor1997.service';


@Component({
  template: require('./ProductSalesfor1997Details.component.html'),
  providers: [ProductSalesfor1997Service
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ProductSalesfor1997DetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objProductSalesfor1997: ProductSalesfor1997Data;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private ProductSalesfor1997Service: ProductSalesfor1997Service

	) {
		// this.id = parseInt(params.get('id'));
		this.objProductSalesfor1997 = new ProductSalesfor1997Data();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.ProductSalesfor1997Service.getByID(+params['id']))
		.switchMap((params: Params) => this.ProductSalesfor1997Service.getByID(params['id']))
		.subscribe((item: ProductSalesfor1997Data) => this.objProductSalesfor1997 = item);
		this.getLookups();
	}

	deleteProductSalesfor1997(id: string) {
		if (window.confirm('Are you sure you want to delete this ProductSalesfor1997?') == true) 
		{
			this.ProductSalesfor1997Service.deleteProductSalesfor1997(this.objProductSalesfor1997.CategoryName.toString())
			.subscribe(record => this.router.navigate(['/ProductSalesfor1997']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('ProductSalesfor1997 record deleted successfully...'); }
			);
		}
	}
	gotoProductSalesfor1997Edit() {
		this.router.navigate(['/ProductSalesfor1997', this.objProductSalesfor1997.CategoryName]);
	}

	gotoProductSalesfor1997() {
		this.router.navigate(['/ProductSalesfor1997']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductSalesfor1997/ProductSalesfor1997Details.component.ts